import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';
import { ITEM_TOTALS_BAR } from '../details-tab/SectionCard';
import { TOTALS_GRID } from './TotalsTableCard';

const HEADING = 'text-subtitle2 new:text-meta new:font-medium';

/** The new design's header row of a Case totals block: muted labels between two rules. */
const NEW_HEADER_BAR = 'border-divider text-foreground-tertiary flex items-center border-y py-2 ps-5 pe-4';

interface Props {
    paymentCurrency: string;
    discountHeaderId?: string;
}

const InvoiceTotalsTableHeader: React.FC<Props> = (props) => {
    const { paymentCurrency, discountHeaderId } = props;
    return (
        <div className={useIsNewDesign() ? NEW_HEADER_BAR : ITEM_TOTALS_BAR}>
            <div className={cn(TOTALS_GRID, 'w-full')}>
                <p className={cn(HEADING, 'col-span-3')}>
                    <FormattedMessage id="invoices.totals-tab.table-headings.description" />
                </p>
                <p className={cn(HEADING, 'col-span-1 text-right')}>
                    <FormattedMessage id={discountHeaderId ?? 'invoices.totals-tab.table-headings.discount'} />
                </p>
                <p className={cn(HEADING, 'col-span-2 text-right')}>
                    <FormattedMessage id="invoices.totals-tab.table-headings.total-without-vat" />
                </p>
                <p className={cn(HEADING, 'col-span-1 text-right')}>
                    <FormattedMessage id="invoices.totals-tab.table-headings.vat" />
                </p>
                <p className={cn(HEADING, 'col-span-2 text-right')}>
                    <FormattedMessage id="invoices.totals-tab.table-headings.total-with-vat" />
                </p>
                <p className={cn(HEADING, 'col-span-2 text-right')}>
                    <FormattedMessage
                        id="invoices.totals-tab.table-headings.total-with-vat-currency"
                        values={{ currency: paymentCurrency }}
                    />
                </p>
            </div>
        </div>
    );
};

export default InvoiceTotalsTableHeader;
